var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxboldsecurityDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9,6.7c0-0.8-0.6-1.7-1.4-2.1l-5.6-2.3c-1.2-0.5-2.7-0.5-3.9,0L4.5,4.7C3.7,5,3.1,5.9,3.1,6.7v4.4 c0,4.9,3.5,9.5,8.4,10.8c0.3,0.1,0.7,0.1,1,0c4.9-1.3,8.4-5.9,8.4-10.8V6.7z M12,7.3c0.4,0,0.8,0.3,0.8,0.8v5 c0,0.4-0.3,0.8-0.8,0.8c-0.4,0-0.7-0.3-0.7-0.8V8C11.3,7.6,11.6,7.3,12,7.3z M12.6,16.8c-0.1,0-0.1,0.1-0.2,0.1 c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2-0.1c-0.1,0-0.1,0-0.2-0.1 c-0.1,0-0.1-0.1-0.1-0.1C11.1,16.5,11,16.3,11,16s0.1-0.5,0.3-0.7c0,0,0.1-0.1,0.1-0.1c0.1,0,0.1-0.1,0.2-0.1 c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.3,0,0.4,0c0.1,0,0.1,0,0.2,0.1c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0.1,0.2,0.1 c0.2,0.2,0.3,0.4,0.3,0.7s-0.1,0.5-0.3,0.7C12.7,16.8,12.6,16.8,12.6,16.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxboldsecurityDanger);
export default __webpack_public_path__ + "static/media/vuesaxboldsecurity-danger.9e2fdaf6a033076abf059c81c4f7a22b.svg";
export { ForwardRef as ReactComponent };